import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import { changeFeedFiltersAutobudgetPriority } from '../../actions/feed-filters/priority-form';
import {
    FeedFilterPriorityForm,
    FeedFilterPriorityFormProps
} from '../../components/FeedFilterPriorityForm/FeedFilterPriorityForm';
import { GdShowConditionAutobudgetPriority } from '../../typings/graphql-grid';
import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';

interface OwnProps {
    isLoading: boolean;
    note?: string;
    onCancel: () => void;
    onSave: () => void;
}

type StateProps = TStateProps<FeedFilterPriorityFormProps, OwnProps>;

type DispatchProps = TDispatchProps<FeedFilterPriorityFormProps, OwnProps>;

const mapStateToProps = (state: State) => {
    const {
        priorityForm: { autobudgetPriority }
    } = state.feedFilters;

    return {
        autobudgetPriority
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
    return {
        onAutobudgetPriorityChange(autobudgetPriority: GdShowConditionAutobudgetPriority) {
            dispatch(changeFeedFiltersAutobudgetPriority(autobudgetPriority));
        }
    };
};

export const FeedFilterPriorityFormContainer = connect<StateProps, DispatchProps, OwnProps>(
    mapStateToProps,
    mapDispatchToProps
)(FeedFilterPriorityForm);
